<template>
  <settings>
    <div>
      <div class="card p-3 p-md-5">
        <div>
          <p class="text-muted page-title pb-2">
            {{ $t('addBox.method') }}
          </p>
          <div v-if="!mobile" class="justify-content-between pt-5 d-flex">
            <div
              v-for="(data, index) in cards"
              :key="index"
              class="shadow-card col-lg-3 col-md-4 p-4"
            >
              <div class="page-title pt-2 pb-3">
                {{ data.title }}
              </div>
              <img :src="data.image" :alt="data.title" class="w-100" />
              <b-card-text class="text-muted pt-4 pb-3" style="min-height: 100px">
                {{ data.content }}
              </b-card-text>
              <b-button
                block
                size="lg"
                variant="primary"
                @click="openDialog(index)"
                :disabled="disabledButton"
              >
                {{ data.button }}
              </b-button>
            </div>
          </div>
          <div v-else class="pb-5">
            <b-carousel id="carousel-no-animation" :interval="0" indicators>
              <b-carousel-slide v-for="(data, index) in cards" :key="index">
                <template #img>
                  <div class="shadow-card p-4 m-1">
                    <div class="page-title pt-2 pb-3">
                      {{ data.title }}
                    </div>
                    <img :src="data.image" :alt="data.title" class="w-100" />
                    <b-card-text class="text-muted pt-4 pb-2" style="min-height: 100px">
                      {{ data.content }}
                    </b-card-text>
                    <b-button
                      block
                      size="lg"
                      class="mb-4"
                      variant="primary"
                      @click="openDialog(index)"
                    >
                      {{ data.button }}
                    </b-button>
                  </div>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
      <b-modal
        v-model="qrDialogCamera"
        centered
        hide-header
        hide-footer
        body-class="p-0"
        size="md"
        @hidden="qrDialogCamera = false"
      >
        <qrcode-stream-koee
          @codeScanned="codeArrived"
          @closeModal="qrDialogCamera = false"
          @error="errorCamera"
        ></qrcode-stream-koee>
      </b-modal>
      <b-modal
        v-model="qrDialogGuid"
        centered
        hide-footer
        hide-header
        body-class="p-0"
        @hidden="qrDialogGuid = false"
      >
        <b-card :class="[mobile ? 'p-0' : 'p-3']">
          <div class="d-flex justify-content-between align-items-center pb-3">
            <h3>{{ $t('addBox.code') }}</h3>
            <b-button variant="transparent" class="p-0" @click="onClose">
              <i class="mdi mdi-close text-muted"></i>
            </b-button>
          </div>
          <div class="mt-4" style="min-height: 80px">
            <b-form-input
              id="inputGuid"
              v-model="guidValue"
              :formatter="formatter"
              :state="validation"
              class="bg-white blacktext"
              placeholder="af-322d"
            ></b-form-input>
            <b-form-invalid-feedback id="inputGuid">
              {{ $t('addBox.guidValidation') }}
            </b-form-invalid-feedback>
          </div>
          <div>
            <div
              :class="
                mobile
                  ? 'd-block'
                  : 'd-flex justify-content-between flex-row-reverse align-items-center pt-3'
              "
            >
              <b-button
                variant="primary"
                :class="{ 'btn-block': mobile }"
                :disabled="!validation"
                :size="buttonSize"
                @click="codeArrived(guidValue, true)"
              >
                {{ $t('button.save.label') }}
              </b-button>
              <b-button
                :class="{ 'btn-block': mobile }"
                :size="buttonSize"
                variant="transparent"
                @click="onClose"
              >
                {{ $t('button.cancel.label') }}
              </b-button>
            </div>
          </div>
        </b-card>
      </b-modal>
    </div>
    <go-to-create-org-modal :modalId="goToCreateOrgModalId"></go-to-create-org-modal>
    <upload-qr-photo-modal
      :modalId="uploadQrPhotoModalId"
      :cameraError="cameraError"
      @codeScanned="codeArrived"
    />
  </settings>
</template>

<script>
import { vueWindowSizeMixin } from 'vue-window-size';
import addBoxMutation from '@/api/boxinfo/mutations/addBoxToOrg.gql';
import boxeQuery from '@/api/boxinfo/boxInfoSettings.gql';
import boxCardsQuery from '@/api/boxCards/boxes.gql';
import scanImg from '@/assets/images/scan-card-img.png';
import photoImg from '@/assets/images/photo-card-img.png';
import codeImg from '@/assets/images/code-card-photo.png';
import Settings from '../Settings.vue';

export default {
  name: 'SettingsAddBox',
  mixins: [vueWindowSizeMixin],
  data() {
    return {
      showTop: true,
      loading: false,
      qrDialogCamera: false,
      qrDialogGuid: false,
      uploadImage: false,
      guidValue: '',
      goToCreateOrgModalId: 'go-to-create-org-modal-id',
      cameraError: '',
      uploadQrPhotoModalId: 'upload-qr-photo-modal',
    };
  },
  components: {
    GoToCreateOrgModal: () => import('@/components/boxes/GoToCreateOrgModal'),
    UploadQrPhotoModal: () => import('@/components/boxes/UploadQrPhotoModal'),
    QrcodeStreamKoee: () => import('@/components/qrcode/QrcodeStream'),
    Settings,
  },
  computed: {
    buttonSize() {
      return this.mobile ? 'md' : 'lg';
    },
    cards() {
      return [
        {
          title: this.$t('addBox.scan'),
          button: this.$t('addBox.scan'),
          content: this.$t('addBox.scanKoeebox'),
          image: scanImg,
        },
        {
          title: this.$t('addBox.foto'),
          button: this.$t('addBox.downloadPhoto'),
          content: this.$t('addBox.photoKoeebox'),
          image: photoImg,
        },
        {
          title: this.$t('addBox.inputCode'),
          button: this.$t('addBox.inputCode'),
          content: this.$t('addBox.codeKoeebox'),
          image: codeImg,
        },
      ];
    },
    isDeflt() {
      return this.$store.getters.isDemo;
    },
    isUser() {
      return this.$store.getters.isUser;
    },
    disabledButton() {
      return !this.isDeflt && this.isUser;
    },
    isVisibleGoToCreateOrgModal() {
      return this.isDeflt && this.isUser;
    },
    mobile() {
      return this.windowWidth < 700;
    },
    validation() {
      const regex = /^([0-F]{2,2})-([0-F]{4,4})$/i;
      return regex.test(this.guidValue);
    },
  },
  methods: {
    errorCamera(error) {
      this.qrDialogCamera = false;
      this.cameraError = error;
      this.$bvModal.show(this.uploadQrPhotoModalId);
    },
    formatter(value) {
      if (value.length == 2 && this.guidValue.length == 2) {
        value = value + '-';
      }
      if (value.charAt(2) != '-' && value.length == 3) {
        value = value.substring(0, 2) + '-' + value.substring(2, value.length);
      }
      if (value.length > 7) {
        value = value.substring(0, 7);
      }
      return value.toUpperCase();
    },
    openDialog(index) {
      switch (index) {
        case 0:
          this.openScanCamera();
          break;
        case 1:
          this.openUploadCamera();
          break;
        case 2:
          this.openWriteGuid();
          break;
        default:
          0;
      }
    },
    openScanCamera() {
      this.cameraError = '';

      if (this.isVisibleGoToCreateOrgModal) {
        this.$bvModal.show(this.goToCreateOrgModalId);
        return;
      }
      this.qrDialogCamera = true;
      this.uploadImage = false;
    },
    openUploadCamera() {
      this.cameraError = '';
      if (this.isVisibleGoToCreateOrgModal) {
        this.$bvModal.show(this.goToCreateOrgModalId);
        debugger;
        return;
      }
      this.$bvModal.show(this.uploadQrPhotoModalId);
    },
    openWriteGuid() {
      if (this.isVisibleGoToCreateOrgModal) {
        this.$bvModal.show(this.goToCreateOrgModalId);
        return;
      }
      this.qrDialogGuid = true;
    },
    onClose() {
      this.qrDialogGuid = false;
    },
    codeArrived(str, isGuid) {
      this.loading = true;
      let guid;
      if (isGuid) {
        guid = str;
      } else {
        const urlList = str.split('/');
        guid = urlList.pop();
      }

      if (!guid) {
        this.showModal(this.$t('addBox.toast.qrNotValid'));
        return;
      }

      this.$apollo
        .mutate({
          mutation: addBoxMutation,
          variables: {
            guid,
          },
          refetchQueries: [
            {
              query: boxeQuery,
              variables: {
                deviceId: guid,
              },
            },
            {
              query: boxCardsQuery,
            },
          ],
        })
        .then(() => {
          this.loading = false;
          this.$bvModal.hide(this.uploadQrPhotoModalId);

          this.$router.push({
            name: 'settingsBoxEdit',
            params: {
              boxId: guid,
            },
          });
        })
        .catch((e) => {
          this.showModal(this.$t('addBox.toast.qrError'));
          console.log(e.message);
        });
    },
    showModal(message) {
      this.$bvModal
        .msgBoxConfirm(message, {
          title: this.$t('toast.error'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          headerBgVariant: 'danger',
          okTitle: this.$t('button.repeat.label'),
          cancelTitle: this.$t('button.cancel.label'),
          headerClass: 'p-2 border-bottom-1',
          footerClass: 'p-1 border-top-0',
          centered: true,
          headerTextVariant: 'light',
          bodyBgVariant: 'dark',
          bodyTextVariant: 'light',
          footerBgVariant: 'dark',
        })
        .then((result) => {
          if (!result) {
            this.$bvModal.hide(this.uploadQrPhotoModalId);
          } else {
            this.loading = false;
            this.$routerCore.GoToHomePage();
          }
        });
    },
  },
};
</script>

<style scoped>
.carousel-caption {
  left: 0%;
  right: 0%;
  position: relative;
  text-align: left;
}
.carousel-indicators li {
  width: 8px;
  height: 8px;
  margin: 0 10px;
  background-color: #707381;
  border-radius: 100%;
  border-top: none;
  border-bottom: none;
}
.carousel-indicators {
  bottom: 0px;
}
.carousel-indicators .active {
  background-color: #ff6d0b;
}
.blacktext {
  color: black !important;
}
</style>
